import { render, staticRenderFns } from "./importcustomers.vue?vue&type=template&id=4a84ff8c&"
import script from "./importcustomers.vue?vue&type=script&lang=js&"
export * from "./importcustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports